import { ObjectMapper } from 'json-object-mapper';
import { JustificationOccurrenceDisciplinaryMeasure } from 'services/enums/JustificationOccurrenceDisciplinaryMeasure.enum';
import { TypeOccurrenceDisciplinaryMeasure } from 'services/enums/TypeOccurrenceDisciplinaryMeasure.enum';
import { IModel } from '../IModel';
import { Model } from '../model';

export class EmployeeDisciplinaryMeasureModel
	extends Model
	implements IModel<EmployeeDisciplinaryMeasureModel>
{
	companyGroupId: string | undefined = undefined;
	employeeId: string | undefined = undefined;
	movementRequestId: string | undefined = undefined;
	occurrenceType: string | number | undefined = undefined;
	occurrenceDate: string | undefined = undefined;
	amountDays: number = 0;
	occurrenceJustification: string | number | null | undefined = undefined;
	note: string = '';
	effectiveDate: string | null | undefined = undefined;

	static create(input: any): EmployeeDisciplinaryMeasureModel {
		return ObjectMapper.deserialize<EmployeeDisciplinaryMeasureModel>(
			EmployeeDisciplinaryMeasureModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}

	get occurrenceTypeEnum(): TypeOccurrenceDisciplinaryMeasure | undefined {
		return resolveDisciplinaryEnum(TypeOccurrenceDisciplinaryMeasure, this.occurrenceType);
	}

	get occurrenceJustificationEnum(): JustificationOccurrenceDisciplinaryMeasure | undefined {
		return resolveDisciplinaryEnum(
			JustificationOccurrenceDisciplinaryMeasure,
			this.occurrenceJustification
		);
	}
}

function resolveDisciplinaryEnum<T extends { getBy(value: string): any; getById(id: number): any }>(
	enumType: T,
	value: string | number | null | undefined
): ReturnType<T['getBy']> | undefined {
	if (value == null || value === '') {
		return undefined;
	}

	if (typeof value === 'number') {
		return enumType.getById(value);
	}

	const byValue = enumType.getBy(value);
	if (byValue) {
		return byValue;
	}

	const asNumber = Number(value);
	if (Number.isFinite(asNumber)) {
		return enumType.getById(asNumber);
	}

	return undefined;
}
